<!-- 商品规格详情 -->
<template>
<div>   
<el-drawer
    title="商品规格详情"
    :visible.sync="dialogVisible"
    :direction="direction"
    :before-close="handleClose"
    size="50%">
    <el-table :data="formData" border>
        <el-table-column type="expand">
            <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="名称">
                    <span>{{ props.row.productName }}</span>
                </el-form-item>
                <el-form-item label="材质">
                    <span>{{ props.row.material }}</span>
                </el-form-item>
                <el-form-item label="尺寸">
                    <span>{{ props.row.size }}</span>
                </el-form-item>
                <el-form-item label="重量">
                    <span>{{ props.row.weight }}</span>
                </el-form-item>
                <el-form-item label="颜色">
                    <span>{{ props.row.colour }}</span>
                </el-form-item>
                <el-form-item label="规格详情">
                    <span>{{ props.row.des }}</span>
                </el-form-item>
                <el-form-item label="规格图片">
                    <span>{{ props.row.des }}</span>
                </el-form-item>
                <el-form-item label="详情图片">
                    <span>{{ props.row.des }}</span>
                </el-form-item>
                </el-form>
            </template>
        </el-table-column>
        <el-table-column property="productName" label="规格名称" width="150"></el-table-column>
        <el-table-column property="productPrice" label="价格(元)" width="200"></el-table-column>
        <el-table-column property="productQuality" label="库存数量"></el-table-column>
        <el-table-column  fixed="right" label="操作">
            <template slot-scope="scope">
                <el-button @click="handleUpdate(scope.row)" type="text" 
                    size="small">编辑</el-button>
                <el-button @click="handleDelete(scope.row)" type="text" 
                    size="small">刪除</el-button>
            </template>
        </el-table-column>
    </el-table>
</el-drawer>

</div>
</template>

<script>
// import AddSpec from './components/addSpec'
export default {
    // components:{
    //     AddSpec
    // },
    props:{       
        title:{
            type: String,
            default: ''
        },
        formData: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            dialogVisible: true,
            direction: 'rtl',
        }
    },
    created() {
      
    },
    mounted() { 
        console.log(this.formData)
    },
    methods: {
        handleUpdate(row){            
            this.isShowGoodsSpec = true
            this.goodsSpecDialogTitle = '编辑规格'
            this.goodsSpecForm = {...row}
            // this.resetForm()            
            this.$emit('close');
        },
        handleDelete(row){
            this.$confirm('确定删除商品规格吗？','警告',).then(res=>{
               this.confirmDelete(row)
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmDelete(row){
            let params = {
                opcode: this.$code.GooodsRemoveSpec,
                v_goods_serial: row.productId,
                i_norms_serial: row.productSpecId
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.$message.success('删除规格成功')   
                    this.$emit('confirm',row.productId)                           
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        closeDialog() {
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        }
    }
}
</script>
<style lang='scss' scoped>
 .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/product/components/specDetailDraw.vue